(function () {
  var parameterName = 'add-to-cart';
  var url = new URL(window.location.href);
  var parameterValue = url.searchParams.get(parameterName);

  if (!parameterValue) return;

  var quantitiesByVariant = {};

  parameterValue.split(',').forEach(function (item) {
    var parts = item.split(':');
    var variantId = Number(parts[0]);
    var quantity = parts.length === 2 ? Number(parts[1]) : 1;

    if (
      parts.length > 2 ||
      !Number.isSafeInteger(variantId) ||
      variantId <= 0 ||
      !Number.isSafeInteger(quantity) ||
      quantity <= 0
    ) {
      return;
    }

    quantitiesByVariant[variantId] = (quantitiesByVariant[variantId] || 0) + quantity;
  });

  var items = Object.keys(quantitiesByVariant).map(function (variantId) {
    return {
      id: Number(variantId),
      quantity: quantitiesByVariant[variantId]
    };
  });

  if (!items.length) {
    console.error('Email cart link does not contain any valid variant IDs.');
    return;
  }

  function cleanUrl() {
    url.searchParams.delete(parameterName);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function updateCartBadges(itemCount) {
    document.querySelectorAll('[data-js-cart-count], [data-cart-count]').forEach(function (badge) {
      badge.textContent = itemCount;
      badge.classList.toggle('hide', itemCount === 0);
    });
  }

  function openCartDrawer(attempt) {
    var currentAttempt = attempt || 0;

    if (
      window.Rebuy &&
      window.Rebuy.SmartCart &&
      typeof window.Rebuy.SmartCart.show === 'function'
    ) {
      window.Rebuy.SmartCart.show();
      return;
    }

    if (currentAttempt >= 50) {
      console.error('Rebuy Smart Cart is unavailable.');
      return;
    }

    window.setTimeout(function () {
      openCartDrawer(currentAttempt + 1);
    }, 100);
  }

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var addUrl = root.replace(/\/?$/, '/') + 'cart/add.js';
  var cartUrl = root.replace(/\/?$/, '/') + 'cart.js';

  fetch(addUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error(error.description || 'Unable to add email products to cart.');
        });
      }

      return response.json();
    })
    .then(function (data) {
      cleanUrl();

      return fetch(cartUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to refresh cart totals.');
        }

        return response.json();
      }).then(function (cart) {
        updateCartBadges(cart.item_count);
        document.dispatchEvent(new CustomEvent('email-cart:added', {
          detail: { addedItems: data, cart: cart }
        }));
        openCartDrawer();
      });
    })
    .catch(function (error) {
      console.error('Email cart link failed:', error);
      document.dispatchEvent(new CustomEvent('email-cart:error', {
        detail: { message: error.message }
      }));
    });
})();